(function () {
  'use strict';
  if (window.__LP_PRIORITY_RUSH__) return;
  window.__LP_PRIORITY_RUSH__ = true;
  const label = 'Skip the Line';
  const legacyLabel = 'Skip the Line — We Start Your Portrait First';
  const tooltip = 'We Start Your Portrait First';
  let frame;
  let dialog;
  let opener;

  function removeTooltip(element) {
    ['title', 'data-original-title', 'data-tippy-content', 'data-tooltip'].forEach(attribute => {
      const value = element.getAttribute(attribute);
      if (value && (value.trim() === tooltip || /^7\s+days\s+faster[.!]?$/i.test(value.trim()))) {
        element.removeAttribute(attribute);
      }
    });
  }

  function showDetails(button) {
    opener = button;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'lp-free-magnet-dialog lp-priority-rush-dialog';
      dialog.setAttribute('aria-label', 'Priority Rush');
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'lp-free-magnet-dialog__close';
      close.setAttribute('aria-label', 'Close');
      close.textContent = '×';
      close.addEventListener('click', () => dialog.close());
      const heading = document.createElement('h2');
      heading.textContent = 'Priority Rush';
      const priority = document.createElement('p');
      priority.textContent = 'We move your order to the front of the production queue.';
      const regular = document.createElement('p');
      regular.textContent = 'Regular start time: 2–3 days.';
      dialog.append(close, heading, priority, regular);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right ||
            event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (opener?.isConnected) opener.focus();
      });
      document.body.append(dialog);
    }
    if (!dialog.open) dialog.showModal();
  }

  function enhance() {
    document.querySelectorAll('.mw-option__value').forEach(card => {
      if (card.closest('.mw-tingle')) return;
      const text = card.querySelector('.mw-option__value-text');
      if (!text) return;
      const current = text.textContent.trim();
      if (!/^Get Your Portrait Sooner(?:\s*\([^)]*\))?$/i.test(current) && current !== label && current !== legacyLabel) return;
      const input = card.querySelector('input[type="checkbox"]');
      const title = card.querySelector('.mw-option__value-title');
      if (!input || !title) return;
      card.classList.add('lp-priority-rush');
      // APO can bind Tippy before this enhancement runs. Remove only the
      // priority label's trigger and instance; keep the price's currency hint.
      title.removeAttribute('data-mw-tooltip');
      title._tippy?.destroy();
      removeTooltip(card);
      card.querySelectorAll('[title], [data-original-title], [data-tippy-content], [data-tooltip]').forEach(removeTooltip);
      const option = card.closest('.mw-option');
      if (option) removeTooltip(option);
      let controls = title.querySelector('.lp-priority-rush__controls');
      if (!controls) {
        controls = document.createElement('span');
        controls.className = 'lp-priority-rush__controls';
        // Move only the app's existing price display, retaining its update target.
        const price = Array.from(card.querySelectorAll('span, small')).find(node =>
          node !== text && !node.contains(text) && !node.querySelector('input') &&
          /^\s*\(?\+.*\d.*\)?\s*$/.test(node.textContent));
        if (price) controls.append(price);
        else {
          const fallback = document.createElement('span');
          fallback.className = 'lp-priority-rush__price';
          const suffix = current.match(/\(\+[^)]*\)/);
          fallback.textContent = suffix ? suffix[0] : '(+$20)';
          controls.append(fallback);
        }
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lp-free-magnet__button lp-priority-rush__button';
        button.textContent = 'Details';
        const icon = document.createElement('span');
        icon.className = 'lp-free-magnet__info';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = 'i';
        button.append(icon);
        button.setAttribute('aria-label', 'Details about priority rush');
        button.setAttribute('aria-haspopup', 'dialog');
        button.addEventListener('click', event => {
          // Details sits inside an APO label; never select the paid option here.
          event.preventDefault();
          event.stopPropagation();
          showDetails(button);
        });
        controls.append(button);
        title.append(controls);
      }
      if (text.textContent !== label) text.textContent = label;
    });
  }
  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(enhance);
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, characterData: true, attributes: true, attributeFilter: ['title', 'data-original-title', 'data-tippy-content', 'data-tooltip', 'data-mw-tooltip'], subtree: true });
  enhance();
})();
